/*
 * @Author: ljiangyun 396242451@qq.com
 * @Date: 2023-11-02 23:29:43
 * @LastEditors: ljiangyun 396242451@qq.com
 * @LastEditTime: 2024-07-03 18:26:29
 * @FilePath: /光明风控平台_PC端/src/store/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  defineStore
} from 'pinia'
 
// 创建store,命名规则： useXxxxStore
// 参数1：store的唯一表示
// 参数2：对象，可以提供state actions getters
 
export const useDataStore = defineStore('data', {
  // data里中的数据
  state: () => ({
    title:'',
    showLeftTop:true,
    showRightTop:true,
    backUrl:'',
    rightButtonValue:true,
    showLeftTopAlways:true
    
  }),
  // 计算属性
  getters: {
    double: state => state.count * 2
  },
  // 相当于 vue中的 methods 既可以写同步代码也可以写异步
  actions: {
    setBackurl (url) {
      this.backUrl = url
    },
    setTitle (title) {
      this.title = title
    },
    setLeftTop(bol){
        this.showLeftTop = bol
    },
    setLeftTopAlways(bol){
      this.showLeftTopAlways = bol
  },
    setRightTop(bol){
        this.showRightTop = bol
    },
    setRightButtonValue(bol){
        this.rightButtonValue = bol
    }
  }
})